import { render, staticRenderFns } from "./CompetitionHeader.vue?vue&type=template&id=70790155&scoped=true"
import script from "./CompetitionHeader.vue?vue&type=script&lang=ts"
export * from "./CompetitionHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70790155",
  null
  
)

export default component.exports